export default [
	{
		path: '/dashboard/:tab?',
		name: 'Dashboard',
		component: () => import('@/views/dashboard/Home.vue'),
		props: true,
		meta: {
			layout: 'Default',
			abilities: [['view', 'workspace-posts']],
			nav: 'dashboard',
		}
	},
]